<template>
  <div class="modal-dialog modal-full" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title" id="create-modal-title">
          {{ $t("create_template_title") }}
        </h3>
        <button
          type="button"
          class="close rounded-pill"
          data-dismiss="modal"
          aria-label="Close"
        >
          <em class="bx bx-x"></em>
        </button>
      </div>
      <div class="modal-body">
        <Alert
          v-if="error"
          :text="$t('Validation for the required fields')"
          type="danger"
          dismissable="false"
        />
        <TemplateForm
          :countries="countries"
          :contractCountry="contractCountry"
          :contractType="contractType"
          :languageData="languageData"
          :languages="languages"
          :onContractTypeChange="onContractTypeChange"
          :onContractCountryChange="onContractCountryChange"
          ref="templateFormRef"
        />
      </div>
      <div class="modal-footer">
        <TButton :label="$t('create_template_close')" data-dismiss="modal" />
        <TButton
          :label="$t('create_template_create')"
          :onClick="createContract"
          active="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TButton from "@/components/Contracts/templates/TButton.vue";
import TemplateForm from "@/components/Contracts/templates/TemplateForm.vue";
import { getCountryName } from "@/app-assets/js/get-countries.js";
import Alert from "@/components/Alerts";
export default {
  props: ["languages", "countries", "type", "getTemplatesDocusign"],
  components: { TButton, TemplateForm, Alert },
  data() {
    return {
      currentCountries: [],
      languageData: {},
      contractCountry: "Choose...",
      contractType: "free_occupancy",
      error: false,
    };
  },
  methods: {
    onContractTypeChange(contractType) {
      this.contractType = contractType.target.value;
    },
    onContractCountryChange(contractCountry) {
      this.contractCountry = contractCountry.target.value;
    },
    countryName(element) {
      if (element) {
        return getCountryName(element.toUpperCase());
      }
    },
    createContractDocusign(terms, details) {
      let self = this;
      this.errorText = "";
      $.blockUI({
        message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
        overlayCSS: {
          backgroundColor: "#fff",
          opacity: 0.8,
          cursor: "wait",
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: "transparent",
        },
      });

      self.$apiCall
        .post("/v1/contracts/templates", {
          details: details,
          country: self.contractCountry,
          type: self.contractType,
          terms: terms,
        })
        .then((response) => {
          $.unblockUI();
          $("#create-contract-modal").modal("hide");
          self.getTemplatesDocusign();
          self.contractCountry = "Choose...";
          self.contractType = "free_occupancy";
          self.editTemplateModal(response.data.uid);
        })
        .catch((error) => {
          this.errorText = `$t('Ops') ${error.response.data.message}`;
          $.unblockUI();
        });
    },

    async createContract() {
      this.error = false;
      let terms = { en: [], ar: [] };
       
      if (this.$refs.templateFormRef.onSubmit()) {
        this.createContractDocusign(terms, this.languageData);
      } else {
        this.error = true;
      }
    },
    onOpen() {
      this.error = false;
      this.$refs.templateFormRef.onOpen();
      this.currentCountries = this.countries;
      this.contractCountry = "Choose...";
      this.contractType = "free_occupancy";
      this.languageData = [
        this.languages.primaryLanguage,
        ...this.languages.secondaryLanguages,
      ].reduce((a, b) => {
        a[b.lang] = {
          title: "",
          description: "",
        };
        return a;
      }, {});
    },
  },
};
</script>
